/* index.tsx generated by @compiled/babel-plugin v0.40.0 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk1j28%7Bbackground-color%3Atransparent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ca0qze3t%7Bpadding-top%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._u5f3ze3t%7Bpadding-right%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._n3tdze3t%7Bpadding-bottom%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19bvze3t%7Bpadding-left%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i1tcg%7Bheight%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1tcg%7Bwidth%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._tzy4idpf%7Bopacity%3A0%7D");
import { type KeyboardEvent, type MouseEvent, useState } from 'react';
import { useIntl } from 'react-intl';
import { IconButton } from '@atlaskit/button/new';
import { cx } from '@atlaskit/css';
import StarIconMigration from '@atlaskit/icon/core/star-starred';
import StarUnstarredIconMigration from '@atlaskit/icon/core/star-unstarred';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Pressable } from '@atlaskit/primitives/compiled';
import messages from './messages';
const styles = {
  pressableStarIcon: "_bfhk1j28 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4t3i1tcg _1bsb1tcg",
  hidden: "_tzy4idpf"
};
export const StarIconButton = ({
  isStarred,
  handleToggle,
  visible = true,
  agentName
}: {
  isStarred: boolean;
  handleToggle: (e: MouseEvent<Element, globalThis.MouseEvent> | KeyboardEvent<Element>) => void;
  visible?: boolean;
  agentName: string;
}): JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const [isHovered, setIsHovered] = useState(false);
  if (fg('rovo_agent_star_icon_button')) {
    return <Box xcss={cx(!visible && styles.hidden)}>
				<IconButton appearance="subtle" spacing="compact" icon={iconProps => isStarred || isHovered ? <StarIconMigration {...iconProps} color={"var(--ds-icon-accent-orange, #E06C00)"} /> : <StarUnstarredIconMigration {...iconProps} color={"var(--ds-icon, #292A2E)"} />} label={formatMessage(isStarred ? messages.removeFromFavouritesLabel : messages.clickToFavouriteLabel, {
        agentName
      })} onClick={handleToggle} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} />
			</Box>;
  }
  return <Pressable xcss={cx(styles.pressableStarIcon, !visible && styles.hidden)} onClick={handleToggle} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
			{isStarred || isHovered ? <StarIconMigration spacing="spacious" label={formatMessage(messages.removeFromFavouritesLabel, {
      agentName
    })} color={"var(--ds-icon-accent-orange, #E06C00)"} /> : <StarUnstarredIconMigration spacing="spacious" label={formatMessage(messages.clickToFavouriteLabel, {
      agentName
    })} color={"var(--ds-icon, #292A2E)"} />}
		</Pressable>;
};